module.exports = __webpack_public_path__ + "static/img/NO.c1098f1d.jpg";